import styled, { keyframes } from 'styled-components';

const backgroundAppear = keyframes`
  from {
    opacity: 0;
    transform: translateY(1rem);
  }
  to {
    opacity: 1;
    transform: translateY(0px);
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 2;

  background: #242424;

  height: 8.6rem;
  width: 100%;

  @media screen and (min-width: 768px) {
    display: none;
  }

  a {
    display: flex;
    align-items: center;
    justify-content: center;

    width: 100%;
    height: 100%;

    > svg {
      .a {
        fill: #000000;
      }
    }

    img {
      width: 4rem;
      height: 4rem;
      object-fit: contain;
    }

    &.active {
      background: #ffdf22;
      /* border-top: 7px solid #000000; */
      animation: ${backgroundAppear} 500ms;
      img {
        filter: brightness(50%) sepia(100) saturate(100) hue-rotate(10deg);
      }
    }
  }
`;
